import { jsx as _jsx } from "react/jsx-runtime";
import { renderLineContent } from "./inline.js";
import { isGroup } from "./lines.js";
import { toLineContent } from "./tokens.js";
import { InnerLine } from "./inner.js";
export function renderLines({ linesOrGroups, handlers, inlineAnnotations, annotationStack = [], }) {
    return linesOrGroups.map((group) => isGroup(group) ? (_jsx(LineBlock, { group: group, handlers: handlers, inlineAnnotations: inlineAnnotations, annotationStack: annotationStack }, group.range[0])) : (_jsx(Line, { line: group, handlers: handlers, inlineAnnotations: inlineAnnotations, annotationStack: annotationStack }, group.lineNumber)));
}
function Line({ line, handlers, inlineAnnotations, annotationStack = [], }) {
    const { lineNumber, totalLines, indentation } = line;
    const lineAnnotations = inlineAnnotations.filter((annotation) => annotation.lineNumber === lineNumber);
    const lineContent = toLineContent(line.tokens, lineAnnotations);
    const stack = buildLineStack(handlers, annotationStack);
    let children = renderLineContent({
        content: lineContent,
        handlers,
        annotationStack,
    });
    const merge = { lineNumber, indentation, totalLines, _stack: stack };
    return (_jsx(InnerLine, { merge: merge, children: children }, lineNumber));
}
// A group of lines targeted by a block annotation
function LineBlock({ group, handlers, inlineAnnotations, annotationStack, }) {
    var _a;
    const { annotation, lines } = group;
    const { name } = annotation;
    const Component = (_a = handlers.find((c) => c.name === name)) === null || _a === void 0 ? void 0 : _a.Block;
    const children = renderLines({
        linesOrGroups: lines,
        handlers,
        inlineAnnotations,
        annotationStack: [...annotationStack, annotation],
    });
    return Component ? (_jsx(Component, { annotation: annotation, children: children })) : (children);
}
function buildLineStack(handlers, annotationStack) {
    const stack = [];
    handlers.forEach(({ name, Line, AnnotatedLine }) => {
        const annotations = annotationStack.filter((a) => a.name === name);
        if (AnnotatedLine) {
            annotations.forEach((annotation) => {
                stack.push({ Component: AnnotatedLine, annotation });
            });
        }
        if (Line) {
            if (!annotations.length) {
                stack.push({ Component: Line });
            }
            annotations.forEach((annotation) => {
                stack.push({ Component: Line, annotation });
            });
        }
    });
    return stack;
}
